import { render } from "./ServicosView.vue?vue&type=template&id=2b870c4b&scoped=true"
import script from "./ServicosView.vue?vue&type=script&lang=js"
export * from "./ServicosView.vue?vue&type=script&lang=js"

import "./ServicosView.vue?vue&type=style&index=0&id=2b870c4b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b870c4b"]])

export default __exports__